import { render, staticRenderFns } from "./Histories.vue?vue&type=template&id=7a7ab197&"
import script from "./Histories.vue?vue&type=script&lang=js&"
export * from "./Histories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports